module.exports = __webpack_public_path__ + "img/left-arm.45deab3c.png";